import React, { useEffect } from 'react';
import { type WrappedComponentProps, injectIntl } from 'react-intl-next';
import Lozenge from '@atlaskit/lozenge';
import { useAnalytics } from '../../../../common/analytics';
import { onConfluenceReactionNudgeShown } from '../../../../common/analytics/events';

import { messages } from './messages';

import { Flex } from '@atlaskit/primitives';

interface ConfluenceReactivationExperimentTabProps {
	title: string;
	isEligibleInactiveUser: boolean | undefined;
	isEligibleNewUser: boolean | undefined;
	isNudgeShown: boolean | undefined;
}

const Tab = ({
	intl,
	title,
	isEligibleInactiveUser,
	isEligibleNewUser,
	isNudgeShown,
}: ConfluenceReactivationExperimentTabProps & WrappedComponentProps) => {
	const { fireAnalyticsEvent } = useAnalytics();

	const displayNudge = !isNudgeShown && (isEligibleInactiveUser || isEligibleNewUser);

	useEffect(() => {
		displayNudge && fireAnalyticsEvent(onConfluenceReactionNudgeShown(!!isEligibleNewUser));
	}, [displayNudge, fireAnalyticsEvent, isEligibleNewUser]);

	return (
		<Flex alignItems="center" columnGap="space.100">
			{title}
			{displayNudge && (
				<Lozenge appearance="new">
					{intl.formatMessage(
						isEligibleNewUser ? messages.never_active_user : messages.inactive_user,
					)}
				</Lozenge>
			)}
		</Flex>
	);
};

export const ConfluenceReactivationExperimentTab = injectIntl(Tab);
